import React from 'react';
import { Typography } from 'antd';
import ErrorPage from 'components/layout/ErrorPage';

const { Text } = Typography;

const UserNoRole = () => {
  return (
    <ErrorPage
      errorCode={403}
      className="standalone-result-page"
      backPage="/login"
      backButtonText="Go Login"
      title="You don't have any role"
      subTitle={<Text>Please contact PMS Admin to assign you a role</Text>}
    />
  );
};

export default UserNoRole;
